module.exports = __webpack_public_path__ + "fonts/Lato-Hairline.5c535860.ttf";